<template>
	<div class="sidebar-logo-container" :class="{'collapse':collapse}">
		<transition name="sidebarLogoFade">
			<router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
				<img v-if="logo" :src="logo" class="sidebar-logo">
				<h1 v-else class="sidebar-title">{{ title }} </h1>
			</router-link>
			<router-link v-else key="expand" class="sidebar-logo-link" to="/">
				<img v-if="logo" :src="logo" class="sidebar-logo">
				<h1 class="sidebar-title">{{ title }} </h1>
			</router-link>
		</transition>
	</div>
</template>

<script>
	import logoImg from '@/assets/logo.png'

	export default {
		name: 'SidebarLogo',
		props: {
			collapse: {
				type: Boolean,
				required: true
			}
		},
		data() {
			return {
				title: '分宜数投招采平台',
				logo: logoImg
			}
		}
	}
</script>

<style lang="scss" scoped>
	.sidebarLogoFade-enter-active {
		transition: opacity 1.5s;
	}

	.sidebarLogoFade-enter,
	.sidebarLogoFade-leave-to {
		opacity: 0;
	}

	.sidebar-logo-container {
		position: relative;
		width: 100%;
		height: 50px;
		line-height: 50px;
		background: #fff;
		text-align: center;
		overflow: hidden;
		border-bottom: 1px solid #f3f4f6;
		box-shadow: 0 15px 12px -15px #000000;

		& .sidebar-logo-link {
			height: 100%;
			width: 100%;

			& .sidebar-logo {
				width: 30px;
				height: 30px;
				vertical-align: middle;
				margin-right: 5px;
			}

			& .sidebar-title {
				display: inline-block;
				margin: 0;
				color: #333;
				font-weight: 600;
				line-height: 50px;
				font-size: 14px;
				vertical-align: middle;
			}
		}

		&.collapse {
			.sidebar-logo {
				margin-right: 0px;
			}
		}
	}
</style>
